var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sound-wave"},[_c('div',{staticClass:"r-1"}),_c('div',{staticClass:"r-2"}),_c('div',{staticClass:"r-3"}),_c('div',{staticClass:"r-4"}),_c('div',{staticClass:"r-5"}),_c('div',{staticClass:"r-6"}),_c('div',{staticClass:"r-5"}),_c('div',{staticClass:"r-4"}),_c('div',{staticClass:"r-3"}),_c('div',{staticClass:"r-2"}),_c('div',{staticClass:"r-1"})])
}]

export { render, staticRenderFns }